import React from 'react';

const ToggleSwitch = ({ isChecked, onChange, id, color = 'blue' }) => {
    const bgColor = isChecked ? `bg-${color}-600` : 'bg-gray-200';
    
    return (
        <label htmlFor={id} className="relative inline-flex items-center cursor-pointer">
            <input 
                type="checkbox" 
                id={id} 
                className="sr-only" 
                checked={isChecked} 
                onChange={onChange} 
            />
            <div className={`w-11 h-6 rounded-full transition-colors ${bgColor}`}>
                <span 
                    className={`absolute top-0.5 left-[2px] h-5 w-5 bg-white rounded-full border border-gray-300 transition-transform duration-200 ease-in-out ${isChecked ? 'transform translate-x-full' : 'transform translate-x-0'}`}
                ></span>
            </div>
        </label>
    );
};

export default ToggleSwitch;